import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";
import React from "react";

const XBadge = ({ label, handleRemove }) => {
  return (
    <Badge
      key={label}
      variant="secondary"
      className="text-sm flex items-center justify-center p-1 pl-2 hover:bg-muted"
    >
      {label}
      <X
        onClick={() => handleRemove(label)}
        size={16}
        className="ml-2 mr-2 hover:text-primary cursor-pointer"
      />
    </Badge>
  );
};

export default XBadge;
